// constants.js
import {ES, FR, BE, US, UK} from "assets/icons/countries";

const BASE_URLS = {
  staging: {
    en: "https://new-staging.chooseandwork.com",
    be: "https://new-staging.chooseandwork.be", 
    fr: "https://new-staging.chooseandwork.fr",
    uk: "https://new-staging.chooseandwork.uk",
    es: "https://new-staging.chooseandwork.es"
  },
  production: {
    en: "https://new.chooseandwork.com",
    be: "https://new.chooseandwork.be", 
    fr: "https://new.chooseandwork.fr",
    uk: "https://new.chooseandwork.uk",
    es: "https://new.chooseandwork.es"
  },
  production2: {
    en: "https://www.chooseandwork.com",
    be: "https://www.chooseandwork.be", 
    fr: "https://www.chooseandwork.fr",
    uk: "https://www.chooseandwork.uk",
    es: "https://www.chooseandwork.es"
  },
  staging2: {
    en: "https://staging.chooseandwork.com",
    be: "https://staging.chooseandwork.be", 
    fr: "https://staging.chooseandwork.fr",
    uk: "https://staging.chooseandwork.uk", 
    es: "https://staging.chooseandwork.es"
  },
  // Add www.new pattern as production3
  production3: {
    en: "https://www.new.chooseandwork.com",
    be: "https://www.new.chooseandwork.be", 
    fr: "https://www.new.chooseandwork.fr",
    uk: "https://www.new.chooseandwork.uk",
    es: "https://www.new.chooseandwork.es"
  }
};

// Helper to detect environment
export const getCurrentEnvironment = () => {
  if (typeof window === 'undefined') return 'production2'; // Default to www for SSR
  
  const hostname = window.location.hostname;
  
  // First check for www.new pattern (highest priority as it's most specific)
  if (hostname.includes('www.new.')) {
    return 'production3';
  }
  
  // Check for staging environments
  if (hostname.includes('new-staging.') || hostname === 'new-staging.chooseandwork.com') {
    return 'staging';
  }
  
  if (hostname.includes('staging.') || hostname === 'staging.chooseandwork.com') {
    return 'staging2';
  }
  
  // Check for new. pattern (without www)
  if (hostname.includes('new.') && !hostname.includes('www.')) {
    return 'production';
  }
  
  // For www domains without "new"
  if (hostname.includes('www.')) {
    return 'production2';
  }
  
  // For root domains without www or new
  if (hostname === 'chooseandwork.com' || 
      hostname === 'chooseandwork.fr' || 
      hostname === 'chooseandwork.be' || 
      hostname === 'chooseandwork.uk' || 
      hostname === 'chooseandwork.es') {
    return 'production2';
  }
  
  // Default to production2 (www)
  return 'production2';
};

// Get current environment name for display/logging
export const getCurrentEnvironmentName = () => {
  const env = getCurrentEnvironment();
  const envNames = {
    staging: 'New Staging',
    staging2: 'Staging',
    production: 'New Production',
    production2: 'Production (www)',
    production3: 'Production (www.new)'
  };
  return envNames[env] || env;
};

export const getLanguages = () => {
  const env = getCurrentEnvironment();
  const baseUrls = BASE_URLS[env];
  
  return [
    { 
      name: "en", 
      value: "en", 
      icon: US,
      url: baseUrls.en,
      displayName: "En"
    },
    { 
      name: "be", 
      value: "be", 
      icon: BE,
      url: baseUrls.be,
      displayName: "Be"
    },
    { 
      name: "fr", 
      value: "fr", 
      icon: FR,
      url: baseUrls.fr,
      displayName: "Fr"
    },
    { 
      name: "uk", 
      value: "en", 
      icon: UK,
      url: baseUrls.uk,
      displayName: "UK"
    },
    { 
      name: "es", 
      value: "es", 
      icon: ES,
      url: baseUrls.es,
      displayName: "Es"
    },
  ];
};

// Also export a function to get just the current environment URLs
export const getCurrentBaseUrls = () => {
  const env = getCurrentEnvironment();
  return BASE_URLS[env];
};

// Helper to get URL for a specific language in current environment
export const getLanguageUrl = (langCode) => {
  const env = getCurrentEnvironment();
  return BASE_URLS[env][langCode];
};

// Helper to get URL for a specific language in a specific environment
export const getLanguageUrlForEnvironment = (langCode, environment) => {
  return BASE_URLS[environment][langCode];
};

// Display names for UI
export const languageDisplayNames = {
  en: "En",
  be: "Be", 
  fr: "Fr",
  uk: "UK",
  es: "Es"
};

// Export all base URLs for reference
export const ALL_BASE_URLS = BASE_URLS;